import { Modal } from 'flowbite';
import type { ModalOptions, ModalInterface } from 'flowbite';
import axios from 'axios';
import JustValidate from 'just-validate';
// import { Rules } from "just-validate/dist/modules/interfaces";
import forgotPassword from './forgot-password';

declare let core_object: any;
declare let localize_object: any;

export default class login{

    elModal: string;
    btnOpenModal: string;
    btnCloseModal: string;
    elForm: string;
    elFormEmail: string;
    elFormPassword: string;
    elFormAlert: string;
    elFormBtn: string;
    elBtnForgotPassword: string;
    elModalForgotPassword: string;
    btnCloseForgotPasswordModal: string;
    elFormSpin: string = 'bgdrop-spin';

    protected url_api_modal: string;
    protected url_api_signin: string;

    /**
     * Constructor
     * @param elModal 
     * @param btnOpenModal 
     * @param btnCloseModal 
     * @param elForm 
     * @param elFormEmail 
     * @param elFormPassword 
     * @param elFormAlert 
     * @param elFormBtn 
     * @param elBtnForgotPassword
     * @param elModalForgotPassword
     * @param btnCloseForgotPasswordModal
     */
    constructor(
        elModal: string,
        btnOpenModal: string,
        btnCloseModal: string,
        elForm: string,
        elFormEmail: string,
        elFormPassword: string,
        elFormAlert: string,
        elFormBtn: string,
        elBtnForgotPassword: string,
        elModalForgotPassword: string,
        btnCloseForgotPasswordModal: string
    ){
        
        this.elModal = elModal;
        this.btnOpenModal = btnOpenModal;
        this.btnCloseModal = btnCloseModal;
        this.elForm = elForm;
        this.elFormEmail = elFormEmail;
        this.elFormPassword = elFormPassword;
        this.elFormAlert = elFormAlert;
        this.elFormBtn = elFormBtn;
        this.elBtnForgotPassword = elBtnForgotPassword;
        this.elModalForgotPassword = elModalForgotPassword;
        this.btnCloseForgotPasswordModal = btnCloseForgotPasswordModal;

        this.url_api_modal = core_object.rest_urls.comments_signin_modal;

        this.url_api_signin = core_object.rest_urls.comments_signin;

    }

    /**
     * Get template
     */
    getTemplateModal(){
        
        const _that = this;
        const el = document.getElementById(this.btnOpenModal);

        el?.addEventListener("click", function(e){
            e.preventDefault();

            const containModal = document.getElementById(_that.elModal);

            if(containModal == null){
                
                const post_data = {
                    ajax_nonce: core_object.ajaxNonce,
                };
        
                const queryString = new URLSearchParams(post_data).toString();
                
                // Call ajax
                axios.post(_that.url_api_modal, queryString)
                    .then(function (response: any) {
                    
                    // Get status
                    const responseStatus: boolean = response.data.status;

                    if(responseStatus == true){

                        const getModal = response.data.template;

                        // Append modal
                        document.body?.insertAdjacentHTML('beforeend', getModal);

                        // Show form
                        _that.showForm(el);

                    }

                    if(responseStatus == false){
                        
                        

                    }

                })
                .catch(function (error:any){

                    

                });
    
            }else{
                
                _that.showForm(el);

            }
 
        });

    }

    /**
     * Get modal
     * @returns 
     */
    protected initModal(){

        const targetEl = document.getElementById(this.elModal) as HTMLElement | null;

        const modalOptions: ModalOptions = {
            placement: 'top-center',
            backdrop: 'static',
            backdropClasses: 'bg-gray-900 bg-opacity-50 fixed inset-0 z-[60]'
        }

        const modal: ModalInterface = new Modal(targetEl, modalOptions);

        modal.hide();

        return modal;

    }
    
    /**
     * Show form
     * @param el 
     */
    protected showForm(el: HTMLElement){
        
        const _that = this;

        const modal = _that.initModal();

        // Set disabled attribute
        el?.setAttribute('disabled', '');

        // Show modal
        modal.show();

        // Validate form
        const validation = _that.validateLogin();
        
        // Close modal
        const elClose = document.getElementById(_that.btnCloseModal);

        elClose?.addEventListener("click", function(e){
            e.preventDefault();
            
            // Destroy validation
            validation.destroy();

            // Remove disabled attribute
            el?.removeAttribute('disabled');

            // Modal Hide
            modal.hide();

        });

        const btnForgotPassword = document.getElementById(this.elBtnForgotPassword);

        btnForgotPassword?.addEventListener("click", function(e){
            e.preventDefault();
            
            // Destroy validation
            validation.destroy();

            // Remove disabled attribute
            el?.removeAttribute('disabled');

            // Modal Hide
            modal.hide();

        });

        // Forgot password
        const modForgotPassword = new forgotPassword(
            this.elBtnForgotPassword,
            this.elModalForgotPassword,
            this.btnCloseForgotPasswordModal
        );
        modForgotPassword.getTemplateModal();

    }

    /**
     * Validation login
     * @returns 
     */
    protected validateLogin(){
        
        const _that = this;

        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid border border-color11-400',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#comment-login-email', [
            {
                rule: 'required',
                errorMessage: core_object.modalLogin.email_required,
            },
            {
                rule: 'email',
                errorMessage: core_object.modalLogin.email_invalid,
            },
        ])
        .addField('#comment-login-password', [
            {
                rule: 'required',
                errorMessage: core_object.modalLogin.password_required,
            },
        ])
        .onSuccess((event: any) => {
                
                event.preventDefault();
            
                _that.sendApi(event?.currentTarget);
                
        });

        return validation;

    }

    /**
     * 
     * @param form Send Credentials
     */
    protected sendApi(form: HTMLFormElement) {
        
        const _that = this;

        // Get form data
        const data = new FormData(form); 
        
        // Conver form data to string
        const datastring = new URLSearchParams(data as any).toString();

        // Button login
        const btn = document.getElementById(this.elFormBtn) as HTMLInputElement | null;

        // Init post data
        const post_data = {
            'fields': datastring
        };

        // Create query string
        const queryString = new URLSearchParams(post_data).toString();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Init spin
        const spin = this.btnSpin();

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(_that.url_api_signin, queryString)
            .then(function (response: any) {

            // Remove alert box
            _that.removeAlertBox();

            // Remove spin
            spin.remove();
                
            // Remove disabled attribute
            btn?.removeAttribute('disabled');

            let responseStatus: boolean = response.data.status;
                
            // True
            if(responseStatus == true){
                
                // Refresh the page
                location.reload();

            }

            // False
            if(responseStatus == false){
                
                // Get errors
                const errors = response.data.errors;
                
                if(Array.isArray(errors)){
                    
                    errors.forEach(function(error){
                        
                        let alert = _that.alertBox(error);
                        form.prepend(alert);

                    });

                }else{
                    
                    const alert = _that.alertBox(errors);
                    form.prepend(alert);

                }
  
            }

        })
        .catch(function (error:any){

            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

    /**
     * Create spin
     * @returns 
     */
    protected btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

    /**
     * Alert Box
     * @param text 
     * @returns 
     */
    protected alertBox(text: string){

        const alert = document.createElement("div");

        alert.setAttribute('role', 'alert');
        alert.classList.add(this.elFormAlert, 'flex', 'basis-full', 'w-full', 'p-4', 'mb-4', 'rounded', 'fluid-text-sm', 'text-red-800', 'bg-red-50');
        alert.innerHTML = '<svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mt-2 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>';
        alert.innerHTML += '<div><span class="font-bold">' + localize_object.error + '</span> ' + text + '</div>';

        return alert;
        
    }

    /**
     * Remove alert box
     */
    protected removeAlertBox(){
        
        const targetModal = document.getElementById(this.elModal) as HTMLElement | null;

        if(targetModal !== null){
            
            const boxes = Array.from(targetModal.getElementsByClassName(this.elFormAlert)) as any;

            boxes.forEach(box => {

                box.remove();

            });
    
        }

    }

    /**
     * Check if is object
     * @param value
     * @returns 
     */
    protected isObject(value: any){

        return Object.prototype.toString.call(value) === '[object Object]';

    }
    
}